import CargoCompanyListParams from "../../../../../../common/services/cargo-company/cargo-company/list/cargo-company-list-params";

const createCargoCompanyLoadParams = (
  displayNameQuery: string | undefined,
): CargoCompanyListParams => {
  return {
    companyDisplayName: !!displayNameQuery ? displayNameQuery : undefined,
  };
};

const mileageDictionaryListingCompanyLoadParamsFactory = {
  createCargoCompanyLoadParams,
};

export default mileageDictionaryListingCompanyLoadParamsFactory;
